import axios from "axios";
import { BASE_URL_API } from "./Constants";
// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.baseURL = `${BASE_URL_API}/mobileapis`;
// axios.defaults.headers.common['Authorization'] = 'Bearer'+AUTH_TOKEN;
axios.defaults.headers.post["Content-Type"] = "application/json";

//---- LOGIN USER ---------------
async function login(email, password) {
  try {
    var config = {
      method: "post",
      url: `/meta-trainer-signin?email=${email}&password=${password}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        APPKEY: "crcN4JRpTjxZ2c6QxXqsKDKkXTLZmPRKu1rkLQ",
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err.response;
  }
}
//changepassword

async function changePasswordd(password, password_confirmation, old_password) {
  let AUTH_TOKEN = window.localStorage.getItem("token");
  try {
    var config = {
      method: "post",
      url: `/navy-update-password?password=${password}&password_confirmation=${password_confirmation}&old_password=${old_password}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        APPKEY: "crcN4JRpTjxZ2c6QxXqsKDKkXTLZmPRKu1rkLQ",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err.response;
  }
}

//Forgot passwor
async function ForgotPasswordd(email) {
  try {
    var config = {
      method: "post",
      url: `navy-forgot-password?email=${email}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        APPKEY: "crcN4JRpTjxZ2c6QxXqsKDKkXTLZmPRKu1rkLQ",
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err.response;
  }
}

//get user info

async function getProgrammsList(
  page,
  is_for_progress,
  keyword,
  groupid,
  goal,
  weekly,
  monthly
) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (page !== undefined) queryParams.append("current_page", page);
    if (is_for_progress !== undefined)
      queryParams.append("is_for_progress", is_for_progress);
    if (keyword !== undefined) queryParams.append("keyword", keyword);
    if (groupid !== undefined) queryParams.append("group_id", groupid);
    if (goal !== undefined) queryParams.append("goal", goal);
    if (weekly !== undefined) queryParams.append("weekly", weekly);
    if (monthly !== undefined) queryParams.append("monthly", monthly);

    var config = {
      method: "get",
      url: `get-trainer-workout-programs-list?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get program for copy workout
async function getProgrammsListLight() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-programs-list`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get single programe details
async function getProgrammDetail(program_id, day, week) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (day !== undefined && day !== "") queryParams.append("day", day);
    // if (group_id !== undefined) queryParams.append('group_id', group_id);
    if (week !== undefined && week !== "" && week !== null) queryParams.append("week", week);

    var config = {
      method: "get",
      url: `get-program-details?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get single programe details
async function getProgrammDetailByDate(program_id, month) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (month !== undefined) queryParams.append("month", month);
    // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append("week", week);

    var config = {
      method: "get",
      url: `get-program-details?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Upload image
async function uploadImage(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    // const queryParams = new URLSearchParams();

    // if (program_id !== undefined) queryParams.append('program_id', program_id);
    // if (day !== undefined) queryParams.append('day', day);
    // // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "post",
      url: `/upload-image`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//create single program

async function createProgram(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    console.log("Create Program payload:", JSON.stringify(data));
    var config = {
      method: "post",
      url: `/create-program`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify(data),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//edit program
async function editProgram(
  program_id,
  name,
  users,
  image,
  desc,
  video,
  group_id,
  is_free,
  price,
  lock_future_weeks,
  community_id,
  program_start_date,
  number_of_weeks,
  is_open_source,
  activityLevels,
  ageRanges,
  genders,
  bmiRanges,
  bmrRanges,
  dcrRanges,
  fitnessGoals
) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    // Build data object, then filter out null/undefined/empty string values
    const rawData = {
      program_id,
      name,
      users,
      image,
      desc,
      video,
      group_id,
      is_free,
      price,
      lock_future_weeks,
      community_id,
      program_start_date,
      number_of_weeks,
      is_open_source,
      activity_levels: activityLevels ? activityLevels.join(",") : "",
      age_ranges: ageRanges ? ageRanges.join(",") : "",
      genders: genders ? genders.join(",") : "",
      bmi_ranges: bmiRanges ? bmiRanges.join(",") : "",
      bmr_ranges: bmrRanges ? bmrRanges.join(",") : "",
      dcr_ranges: dcrRanges ? dcrRanges.join(",") : "",
      fitness_goals: fitnessGoals ? fitnessGoals.join(",") : ""
    };

    // Remove keys with null, undefined, or empty string values
    const data = Object.fromEntries(
      Object.entries(rawData).filter(
        ([_, v]) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "")
      )
    );

    var config = {
      method: "post",
      url: `edit-program`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify(data),
    };
    console.log("Edit Program payload:", JSON.stringify(data));
    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//duplicate program
async function duplicateProgram(program_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    // if (day !== undefined) queryParams.append('day', day);
    // // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "post",
      url: `/duplicate_program?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//FInde users for programm

async function getProgrammUsers(keyword, current_page) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `search?keyword=${keyword}&current_page=${current_page}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
// delete programm

async function deleteProgramm(program_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `delete-program?program_id=${program_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get user community
async function getUserCommunity() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: "/get-user_owner_communities-list",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//workout groups
async function getUserGroups() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: "get_owner_workouts_groups_v2",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
/////////////////===================Workouts======================/////////////

////create workout
async function createWorkoutt(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    // const queryParams = new URLSearchParams();

    // if (program_id !== undefined) queryParams.append('program_id', program_id);
    // if (day !== undefined) queryParams.append('day', day);
    // // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "post",
      url: `create_workout_v2`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//edit workout
async function editWorkoutt(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    // const queryParams = new URLSearchParams();

    // if (program_id !== undefined) queryParams.append('program_id', program_id);
    // if (day !== undefined) queryParams.append('day', day);
    // // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "post",
      url: `edit_workout_v2`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get excercise list

async function getExcerciseList(current_page, keyword) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (current_page !== undefined)
      queryParams.append("current_page", current_page);
    if (keyword !== undefined) queryParams.append("keyword", keyword);
    // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "get",
      url: `get-exercises-list?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get general fields
async function getgeneralFields() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-general-fields`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get trainer excercises

async function getTrainerExercises(current_page, keyword) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (current_page !== undefined)
      queryParams.append("current_page", current_page);

    if (keyword !== undefined) queryParams.append("keyword", keyword);

    var config = {
      method: "get",
      url: `get-trainer-exercises-list?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//crteae excercise

async function createExercise(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `create-exercise`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//edit excercise

async function editExercise(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `edit-exercise`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//delete work out
async function deleteWorkout(workout_id, day) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);
    if (day !== undefined) queryParams.append("day", day);

    var config = {
      method: "post",
      url: `delete_workout?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// get single workout detail

async function getWorkoutDetail(workout_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);
    // if (day !== undefined) queryParams.append('day', day);

    var config = {
      method: "get",
      url: `get_workout_details_v2?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Remove user from program

async function removeUserFromProgram(program_id, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (user_id !== undefined) queryParams.append("user_id", user_id);

    var config = {
      method: "post",
      url: `delete-program-member?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
async function removeGroupFromProgram(program_id, group_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (group_id !== undefined) queryParams.append("group_id", group_id);

    var config = {
      method: "post",
      url: `unassign-group-program?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//ReOpen program

async function reopenProgramuser(program_id, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (user_id !== undefined) queryParams.append("user_id", user_id);

    var config = {
      method: "post",
      url: `reopen_program?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//reopen for group
async function reopenProgramgroup(program_id, group_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (group_id !== undefined) queryParams.append("group_id", group_id);

    var config = {
      method: "post",
      url: `reopen_program?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Mark program complet for user

async function completeProgramuser(program_id, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (user_id !== undefined) queryParams.append("user_id", user_id);

    var config = {
      method: "post",
      url: `mark_program_complete?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//complete program for group
async function completeProgramgroup(program_id, group_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (group_id !== undefined) queryParams.append("group_id", group_id);

    var config = {
      method: "post",
      url: `mark_program_complete?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Add excercises for workout
async function addWorkoutexcercises(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `add_workout_exercises`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// duplicate workou
async function duplicateWorkout(program_id, workout_id, datee) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);
    if (datee !== undefined) queryParams.append("date", datee);

    var config = {
      method: "post",
      url: `duplicate_workout?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
// duplicate excercise
async function duplicateExcercise(program_id, workout_id, workout_exercise_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (program_id !== undefined) queryParams.append("program_id", program_id);
    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);

    if (workout_exercise_id !== undefined)
      queryParams.append("workout_exercise_id", workout_exercise_id);

    var config = {
      method: "post",
      url: `duplicate_exercise?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// remove excercise
async function deleteExcercise(workout_id, id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);

    if (id !== undefined) queryParams.append("id", id);

    var config = {
      method: "post",
      url: `remove_workout_exercise?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//add workout sets
async function addWorkoutSets(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `add_workout_exercise_sets`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//delete set

async function deleteSet(set_id, workout_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (set_id !== undefined) queryParams.append("set_id", set_id);

    if (workout_id !== undefined) queryParams.append("workout_id", workout_id);

    var config = {
      method: "post",
      url: `delete-set?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//create share link
async function createProgramLink(actual_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `create-shared-link?type=program&actual_id=${actual_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
async function copyWorkouts(target_program_id, workout_ids, week, day) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (target_program_id !== undefined)
      queryParams.append("target_program_id", target_program_id);

    if (workout_ids !== undefined)
      queryParams.append("workout_ids", workout_ids);
    if (week !== undefined) queryParams.append("week", week);

    if (day !== undefined) queryParams.append("day", day);

    var config = {
      method: "post",
      url: `/copy_workout?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//reorder program
async function reOrderExercises(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `reorder-workout-exercises`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//reorder workouts
async function reOrderWorkouts(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `reorder-program-workouts`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//merge excercises
async function mergeExercises(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    // const queryParams = new URLSearchParams();

    // if (program_id !== undefined) queryParams.append('program_id', program_id);
    // if (day !== undefined) queryParams.append('day', day);
    // // if (group_id !== undefined) queryParams.append('group_id', group_id);
    // if (week !== undefined) queryParams.append('week', week);

    var config = {
      method: "post",
      url: `add_edit_merge_exercises`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
////get trainer stats
async function getTrainerDashboardStats() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get trainer clients

async function getTrainerDashboardClients(type) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-clients?type=${type}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get trainer groups
async function getTrainerDashboardGroups() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-groups`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get trainer activities
async function getTrainerDashboardActivities() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-activities`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get trainer challenges
async function getTrainerDashboardChallenges() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-challenges`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
async function getTrainerDashboardClientStats(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-client-specific?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Get Group members
async function getTrainerGroupMembers(group_id, current_page) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get_group_members_v2?group_id=${group_id}&current_page=${current_page}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//Get Group members for challenges
async function getTrainerChallengeMembers(current_page, challenge_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get-challenge-members?current_page=${current_page}&challenge_id=${challenge_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Get checkedin members for activities
async function getTrainerActivityeMembers(activity_id, current_page) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `get_checkin_group_activities_list_v2?activity_id=${activity_id}&current_page=${current_page}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get tariner clients programms
async function getTrainerClientAssignedPrograms(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-trainer-dashboard-stats-client-specific-programs?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get tariner clients programms
async function getTrainerClientAssignedGroups(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-trainer-dashboard-stats-client-specific-groups?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get tariner clients Challenges
async function getTrainerClientAssignedChallenges(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-trainer-dashboard-stats-client-specific-challenges?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get user profile

async function getUserProfile(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-user-profile?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//user stats
async function getUserStats(platform, start_date, end_date, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (platform !== undefined) queryParams.append("platform", platform);
    if (start_date !== undefined) queryParams.append("start_date", start_date);
    if (end_date !== undefined) queryParams.append("end_date", end_date);
    if (user_id !== undefined) queryParams.append("user_id", user_id);

    var config = {
      method: "get",
      url: `get-activity-data?${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//plateform apps types
async function getAppTypes(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-platform-integration-settings?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get user strength excerciselist

async function getStrenghtExercises(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-strength-exercises-list?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//get Trainer client exercise list

async function getTarinerExercises(user_id, date_from, date_to, keyword) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const queryParams = new URLSearchParams();

    if (user_id !== undefined || user_id != "")
      queryParams.append("user_id", user_id);
    if (date_from !== undefined || date_from != "")
      queryParams.append("date_from", date_from);
    if (date_to !== undefined || date_to != "")
      queryParams.append("date_to", date_to);
    if (keyword !== undefined || keyword !== "")
      queryParams.append("keyword", keyword);

    var config = {
      method: "get",
      url: `/get-my-workout-exercises-list?medium=trainer&${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// get exercise stats
async function getTarinerExerciseStats(
  exercise_id,
  date_from,
  date_to,
  user_id
) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    const queryParams = new URLSearchParams();

    if (exercise_id !== undefined || exercise_id != "")
      queryParams.append("exercise_id", exercise_id);
    if (date_from !== undefined || date_from != "")
      queryParams.append("date_from", date_from);
    if (date_to !== undefined || date_to != "")
      queryParams.append("date_to", date_to);
    if (user_id !== undefined || user_id != "")
      queryParams.append("user_id", user_id);

    var config = {
      method: "get",
      url: `/get-exercise-stats?medium=trainer&${queryParams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Get Profile traing fields api start

//Get Profile traing fields
async function getProfileTrainingFields(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/get-profile-training-fields?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//add new field api
async function addNewProfileTrainingField(user_id, field_name, field_type) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `add-profile-training-field?user_id=${user_id}&field_name=${field_name}&field_type=${field_type}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//edit training field

async function editProfileTrainingField(id, field_name, field_type, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `edit-profile-training-field?id=${id}&field_name=${field_name}&field_type=${field_type}&user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//delete field
async function deleteProfileTrainingField(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `delete-profile-training-field?id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Get Profile traing fields values api start

//Get Profile traing fields value
async function getProfileTrainingFieldsValues(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/get-profile-training-field-values?user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//add profile training values
async function addProfileTrainingFieldsValues(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-profile-training-field-value`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
//add profile training values
async function editProfileTrainingFieldsValues(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/edit-profile-training-field-value`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//delete training field value
async function deleteProfileTrainingFieldsValue(id, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/delete-profile-training-field-value?id=${id}&user_id=${user_id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//Quick workouts
//delete training field value
async function getUserQuickWorkouts(user_id, current_page) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/get-quick-workouts?user_id=${user_id}&current_page=${current_page}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

/* ------ Start User Trainer List APIS ------ */

// fetchng the trainer users lists
async function getTrainerUsersLists() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-trainer-users-lists`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// creating trainer users list name
async function createTrainerUsersList(name) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/create-trainer-users-list`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ name }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Edidting Trainer list name
async function editTrainerUsersList(name, id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/edit-trainer-users-list`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ name, id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Deleting the User List name
async function deleteTrainerUsersList(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/delete-trainer-users-list`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// creating user list for tor tainer usr lists
async function addTrainerUsersListUser(user_ids, trainer_users_lists_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-trainer-users-list-user`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ user_ids, trainer_users_lists_id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// getting trainer user's list against list name id
async function getTrainerUsersListUsers(trainer_users_lists_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-trainer-users-list-users`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      params: { trainer_users_lists_id },
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// deleting trainer users lists against list name id and users ids
async function removeTrainerUsersListUser(user_ids, trainer_users_lists_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/remove-trainer-users-list-user`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ user_ids, trainer_users_lists_id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Adding new group members in trainter groups
async function addGroupMembersV2(group_id, members) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-group-members_v2`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ group_id, members }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// fetchng the usser body changs data
async function getBodyChanges(current_page, type, user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-body-changes`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      params: { current_page, type, user_id },
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Adding new body changes
async function addEditBodyChanges(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-edit-body-changes`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Deleting the body changs
async function deleteBodyChanges(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/delete_body_changes`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Adding new body change image
async function addBodyChangesImage(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-body-change-image`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// Deleting the body changs images
async function deleteBodyChangeImage(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/delete-body-change-image`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ id }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// fetchng the usser body changs trainers list
async function getBodyChangesTrainers(user_id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/get-body-changes-trainers`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      params: { user_id },
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// seraching the usser body changs trainers
async function getSearch(keyword, current_page, account_type) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "get",
      url: `/search`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      params: { keyword, current_page, account_type },
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// adding new body changes triner
async function addBodyChangesTrainer(user_ids) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/add-body-changes-trainers`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ user_ids }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}
// Deleting the body changes triner
async function removeBodyChangesTrainer(user_ids) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");

    var config = {
      method: "post",
      url: `/remove-body-changes-trainer`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: JSON.stringify({ user_ids }),
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//edit profile
async function editProfile(
  user_id,
  name,
  dob,
  weight,
  weight_unit,
  height,
  height_unit,
  interests,
  activities,
  about
) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    const fromData = new URLSearchParams();

    if (user_id !== undefined) fromData.append("user_id", user_id);
    if (name !== undefined) fromData.append("name", name);
    if (dob !== undefined) fromData.append("dob", dob);
    if (weight !== undefined) fromData.append("weight", weight);
    if (weight_unit !== undefined) fromData.append("weight_unit", weight_unit);
    if (height !== undefined) fromData.append("height", height);
    if (height_unit !== undefined) fromData.append("height_unit", height_unit);

    if (interests !== undefined)
      fromData.append("interests", JSON.stringify(interests));
    if (activities !== undefined)
      fromData.append("activities", JSON.stringify(activities));

    if (about !== undefined) fromData.append("about", about);

    var config = {
      method: "post",
      url: `profile?${fromData}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

export const Services = {
  login,
  ForgotPasswordd,
  changePasswordd,
  getProgrammsList,
  getProgrammDetail,
  getProgrammDetailByDate,
  createProgram,
  uploadImage,
  getProgrammUsers,
  deleteProgramm,
  getUserCommunity,
  getUserGroups,
  createWorkoutt,
  editWorkoutt,
  editProgram,
  getExcerciseList,
  getgeneralFields,
  createExercise,
  deleteWorkout,
  getWorkoutDetail,
  removeUserFromProgram,
  reopenProgramuser,
  reopenProgramgroup,
  completeProgramuser,
  completeProgramgroup,
  duplicateProgram,
  addWorkoutexcercises,
  duplicateWorkout,
  duplicateExcercise,
  deleteExcercise,
  addWorkoutSets,
  deleteSet,
  createProgramLink,
  copyWorkouts,
  removeGroupFromProgram,
  getProgrammsListLight,
  reOrderExercises,
  reOrderWorkouts,
  getTrainerExercises,
  editExercise,
  mergeExercises,
  getTrainerDashboardStats,
  getTrainerDashboardClients,
  getTrainerDashboardGroups,
  getTrainerDashboardActivities,
  getTrainerDashboardChallenges,
  getTrainerDashboardClientStats,
  getTrainerGroupMembers,
  getTrainerChallengeMembers,
  getTrainerActivityeMembers,
  getTrainerClientAssignedPrograms,
  getTrainerClientAssignedGroups,
  getTrainerClientAssignedChallenges,
  getUserProfile,
  getUserStats,
  getAppTypes,
  getStrenghtExercises,
  getTarinerExercises,
  getTarinerExerciseStats,
  getProfileTrainingFields,
  getProfileTrainingFieldsValues,
  addProfileTrainingFieldsValues,
  addNewProfileTrainingField,
  deleteProfileTrainingField,
  editProfileTrainingField,
  deleteProfileTrainingFieldsValue,
  editProfileTrainingFieldsValues,
  getUserQuickWorkouts,
  // users lsit start functions
  createTrainerUsersList,
  getTrainerUsersLists,
  editTrainerUsersList,
  deleteTrainerUsersList,
  addTrainerUsersListUser,
  getTrainerUsersListUsers,
  removeTrainerUsersListUser,
  addGroupMembersV2,
  getBodyChanges,
  addEditBodyChanges,
  deleteBodyChanges,
  addBodyChangesImage,
  deleteBodyChangeImage,
  getBodyChangesTrainers,
  getSearch,
  addBodyChangesTrainer,
  removeBodyChangesTrainer,
  editProfile,
  // usres list end functions
};
